import CalendarDetailWidget from './calendar-detail-widget';
import FeaturesWidget from './features-widget';
import SiteDetailWidget from './site-detail-widget';

const SiteSettings = () => {
  return (
    <div className="flex-column gap-16">
      <SiteDetailWidget />
      <CalendarDetailWidget />
      <FeaturesWidget />
    </div>
  );
};

export default SiteSettings;
